import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import autoBind from 'react-autobind';
import { fetchOptions, clearOptionsErrors, deleteOption } from '../../actions';
import ActionButtons from '../home/ActionButtons';
import Alert from '../home/Alert';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from 'material-ui/Table';
import DialogModal from '../home/DialogModal';

const propTypes = {
  dispatch: PropTypes.func,
  options: PropTypes.object,
  optionDelete: PropTypes.bool,
};

class ShowOptions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      deleteId: '',
      alertOpen: false,
      alertMessage: '',
      delete: false,
    };
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.optionDelete && (this.state.delete || nextProps.options.delete)) {
      const options = nextProps.options;
      options.delete = false;
      this.setState({
        delete: false,
        alertOpen: true,
        alertMessage: 'Option deleted!',
        options,
      });
      this.handleClose();
    }
    if (nextProps.error) {
      this.setState({
        delete: false,
        alertOpen: true,
        alertMessage: `${nextProps.error.statusCode} ${nextProps.error.error} ${nextProps.error.message}`,
      });
    }
  }
  handleOpen(id) {
    this.setState({
      open: true,
      deleteId: id,
    });
  }
  handleClose() {
    this.setState({
      open: false,
      deleteId: '',
    });
  }
  handleDelete() {
    this.setState({
      delete: true,
    });
    this.props.dispatch(deleteOption(this.state.deleteId));
    this.props.dispatch(fetchOptions());
  }
  alertHandleClose() {
    this.setState({
      alertMessage: '',
      alertOpen: false,
    });
    this.props.dispatch(clearOptionsErrors());
    this.props.dispatch(fetchOptions());
  }
  renderRowsTable() {
    return this.props.options.results.map((option, i) =>
      <TableRow key={i}>
        <TableRowColumn key={i}>{option.name}</TableRowColumn>
        <TableRowColumn key={i}>
          <ActionButtons
            onDelete={() => this.handleOpen(option.id)}
            onEdit={`/options/${option.id}`}
            onView={`/options/view/${option.id}`}
            disableForOperators
          />
        </TableRowColumn>
      </TableRow>
    );
  }
  render() {
    const tableStyles = {
      stripedRows: true,
      displaySelectAll: false,
      adjustForCheckbox: false,
      selectable: false,
      displayRowCheckbox: false,
    };
    return (
      <div>
        <DialogModal
          dialogOpen={this.state.open}
          dialogHandleClose={this.handleClose}
          dialogHandleSubmit={() => this.handleDelete()}
          dialogTitle="Delete Option"
          dialogMessage="Do you really want to delete this option?"
          dialogActionTitle="Delete"
        />
        <Alert
          alertOpen={this.state.alertOpen}
          alertHandleClose={() => this.alertHandleClose()}
          alertMessage={this.state.alertMessage}
        />
        <Table selectable={false}>
          <TableHeader
            displaySelectAll={tableStyles.displaySelectAll}
            adjustForCheckbox={tableStyles.adjustForCheckbox}
          >
            <TableRow
              selectable={tableStyles.selectable}
            >
              <TableHeaderColumn>Name</TableHeaderColumn>
              <TableHeaderColumn style={{ textAlign: 'center' }}>Actions</TableHeaderColumn>
            </TableRow>
          </TableHeader>
          <TableBody
            stripedRows={tableStyles.stripedRows}
            displayRowCheckbox={tableStyles.displayRowCheckbox}
          >
            {this.renderRowsTable()}
          </TableBody>
        </Table>
      </div>
    );
  }
}

ShowOptions.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

ShowOptions.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    error: state.options.error,
    optionDelete: state.options.optionDelete,
    options: state.options,
  };
}

export default connect(mapStateToProps)(ShowOptions);



// WEBPACK FOOTER //
// ./src/components/options/ShowOptions.js